import { useAnalytics } from '@magnetic/analytics';
import React, { forwardRef, useCallback } from 'react';
import { TagFrame } from './frame/index.js';
import './frame/style.css.js';

const Tag = forwardRef(
  ({ analytics, children, onClose, ...props }, ref) => {
    const { sendAnalytics } = useAnalytics();
    const handleAnalytics = useCallback(
      (e) => {
        var _a;
        if (analytics == null ? void 0 : analytics.events.includes("click")) {
          sendAnalytics({
            ...analytics,
            component: "tag",
            event: "click",
            data: {
              ...analytics.data,
              button: Boolean((_a = analytics.data) == null ? void 0 : _a.buttonCta)
            }
          });
        }
        onClose == null ? void 0 : onClose(e);
      },
      [analytics, onClose, sendAnalytics]
    );
    return /* @__PURE__ */ React.createElement(TagFrame, {
      ...props,
      onClose: onClose && handleAnalytics,
      ref
    }, children);
  }
);
Tag.displayName = "Tag";

export { Tag };
//# sourceMappingURL=tag.js.map
